export const ORDERING_STAGES = {
    ADDRESS: 'ADDRESS',
    CONFIRMATION: 'CONFIRMATION',
    EMAIL: 'EMAIL',
    ERROR: 'ERROR',
    GET_PRICE: 'GET_PRICE',
    MESSAGE: 'MESSAGE',
    STRIPE: 'STRIPE',
}

// Return true/false if resource that has been bought before by the same person
export const hasOrderedBefore = ({ allTransactions, currentTransaction }) =>
    !!allTransactions.find(({ productId, resourceId }) => currentTransaction.resourceId === resourceId && currentTransaction.productId === productId)

export const confirmStripePayment = async ({ stripe, clientSecret, card }) => {
    try {
        const response = await stripe.confirmCardPayment(clientSecret, { payment_method: { card } })

        if (response?.error) {
            throw new Error(response.error.message)
        }
    } catch (error) {
        throw new Error(error).message
    }
}
